import React from "react";

/** Inactive / active sidebar icon colors (match `Sidebar` `ListItemIcon`). */
export const SIDEBAR_ICON_INACTIVE = "rgba(108, 117, 125, 1)";
export const SIDEBAR_ICON_ACTIVE = "rgba(22, 67, 135, 1)";

/** Outline inactive glyphs look lighter; always use the filled path for consistent weight. */
const sidebarGlyph = (filledPath: string, _outlinePath: string) => filledPath;

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
  isActive?: boolean;
}

export const DashboardIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1188)">
      <path 
        d="M11.875 0.625H3.125C1.39938 0.625 0 2.02438 0 3.75V8.75C0 10.4756 1.39938 11.875 3.125 11.875H6.875V13.125H4.375C4.02938 13.125 3.75 13.405 3.75 13.75C3.75 14.095 4.02938 14.375 4.375 14.375H10.625C10.9706 14.375 11.25 14.095 11.25 13.75C11.25 13.405 10.9706 13.125 10.625 13.125H8.125V11.875H11.875C13.6006 11.875 15 10.4756 15 8.75V3.75C15 2.02438 13.6006 0.625 11.875 0.625ZM4.25125 9.59937C3.05813 9.31875 2.12375 8.31312 1.92062 7.10437C1.6275 5.36 2.78125 3.82375 4.375 3.5V6.30312C4.375 6.63438 4.50688 6.9525 4.74125 7.18687L6.72188 9.1675C6.03875 9.62 5.17 9.815 4.25125 9.59937ZM7.60562 8.28375L5.80875 6.48687C5.69125 6.36937 5.62563 6.21063 5.62563 6.045V3.50062C7.05188 3.79 8.12563 5.05062 8.12563 6.5625C8.12563 7.19938 7.93313 7.79 7.60562 8.28375ZM12.5006 9.375H10.6256C10.2806 9.375 10.0006 9.095 10.0006 8.75C10.0006 8.405 10.2806 8.125 10.6256 8.125H12.5006C12.8456 8.125 13.1256 8.405 13.1256 8.75C13.1256 9.095 12.8456 9.375 12.5006 9.375ZM12.5006 6.875H10.6256C10.2806 6.875 10.0006 6.595 10.0006 6.25C10.0006 5.905 10.2806 5.625 10.6256 5.625H12.5006C12.8456 5.625 13.1256 5.905 13.1256 6.25C13.1256 6.595 12.8456 6.875 12.5006 6.875ZM12.5006 4.375H10.6256C10.2806 4.375 10.0006 4.095 10.0006 3.75C10.0006 3.405 10.2806 3.125 10.6256 3.125H12.5006C12.8456 3.125 13.1256 3.405 13.1256 3.75C13.1256 4.095 12.8456 4.375 12.5006 4.375Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1188">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const UserManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1570)">
      <path 
        d="M 7.63007 14.375 H 1.26632 C 1.09757 14.375 0.936324 14.3069 0.818199 14.1856 C 0.700699 14.065 0.636949 13.9012 0.641324 13.7325 C 0.734449 10.2863 2.3707 8.74937 5.94507 8.74937 C 6.12695 8.74937 6.3007 8.75625 6.4732 8.76437 C 6.32695 9.305 6.25007 9.92125 6.25007 10.6244 C 6.25007 12.3763 6.70007 13.6125 7.63007 14.375 Z M 5.94507 7.5 C 8.29007 7.5 9.38257 6.4075 9.38257 4.0625 C 9.38257 1.7175 8.29007 0.625 5.94507 0.625 C 3.60007 0.625 2.50757 1.7175 2.50757 4.0625 C 2.50757 6.4075 3.60007 7.5 5.94507 7.5 Z M 14.1713 12.5231 C 13.9094 12.9694 13.3344 13.1194 12.8882 12.8569 L 12.5951 12.685 C 12.3932 12.8306 12.1513 12.9375 11.8745 13.01 V 13.4375 C 11.8745 13.955 11.4545 14.375 10.937 14.375 C 10.4194 14.375 9.99945 13.955 9.99945 13.4375 V 13.01 C 9.72257 12.9375 9.4807 12.8312 9.27882 12.685 L 8.9857 12.8569 C 8.53945 13.1187 7.96445 12.9694 7.70257 12.5231 C 7.4407 12.0769 7.59007 11.5019 8.03632 11.24 L 8.45445 10.9944 C 8.4432 10.8769 8.43632 10.7544 8.43632 10.6244 C 8.43632 10.4944 8.4432 10.3725 8.45445 10.2544 L 8.03632 10.0087 C 7.59007 9.74687 7.44007 9.17188 7.70257 8.72563 C 7.96445 8.27938 8.53945 8.12937 8.9857 8.39188 L 9.27882 8.56375 C 9.4807 8.41812 9.72257 8.31125 9.99945 8.23875 V 7.81125 C 9.99945 7.29375 10.4194 6.87375 10.937 6.87375 C 11.4545 6.87375 11.8745 7.29375 11.8745 7.81125 V 8.23875 C 12.1513 8.31125 12.3932 8.4175 12.5951 8.56375 L 12.8882 8.39188 C 13.3344 8.13 13.9094 8.27938 14.1713 8.72563 C 14.4332 9.17188 14.2838 9.74687 13.8376 10.0087 L 13.4195 10.2544 C 13.4307 10.3719 13.4376 10.4944 13.4376 10.6244 C 13.4376 10.7544 13.4307 10.8762 13.4195 10.9944 L 13.8376 11.24 C 14.2838 11.5019 14.4338 12.0769 14.1713 12.5231 Z M 11.8751 10.625 C 11.8751 9.88 11.6826 9.6875 10.9376 9.6875 C 10.1926 9.6875 10.0001 9.88 10.0001 10.625 C 10.0001 11.37 10.1926 11.5625 10.9376 11.5625 C 11.6826 11.5625 11.8751 11.37 11.8751 10.625 Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1570">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const StaffManagementIcon: React.FC<IconProps> = ({
  width = 15,
  height = 15,
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false,
}) => {
  // Default gray, active → primary blue
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 15"
      className={className}
    >
      <g clipPath="url(#clip0_1127_1575)">
        <path
          d={sidebarGlyph("M 10.7906 5.23687 L 10.1762 4.88313 C 10.2569 4.62188 10.3125 4.35 10.3125 4.0625 C 10.3125 3.775 10.2569 3.50312 10.1762 3.24187 L 10.7906 2.88812 C 11.09 2.71625 11.1931 2.33375 11.02 2.035 C 10.8481 1.73563 10.4663 1.63187 10.1669 1.80562 L 9.55625 2.1575 C 9.17813 1.75 8.68563 1.45375 8.12563 1.32563 V 0.625 C 8.12563 0.279375 7.84625 0 7.50063 0 C 7.155 0 6.87563 0.279375 6.87563 0.625 V 1.32563 C 6.31563 1.45375 5.8225 1.74937 5.445 2.1575 L 4.83437 1.80562 C 4.535 1.6325 4.1525 1.73625 3.98125 2.035 C 3.80875 2.33438 3.91188 2.71625 4.21063 2.88812 L 4.825 3.24187 C 4.74437 3.50312 4.68875 3.775 4.68875 4.0625 C 4.68875 4.35 4.74437 4.62188 4.825 4.88313 L 4.21063 5.23687 C 3.91125 5.40875 3.80813 5.79125 3.98125 6.09 C 4.09687 6.29063 4.30688 6.40312 4.52313 6.40312 C 4.62875 6.40312 4.73625 6.37625 4.83437 6.31938 L 5.445 5.9675 C 5.82312 6.375 6.31563 6.67125 6.87563 6.79937 V 7.5 C 6.87563 7.84562 7.155 8.125 7.50063 8.125 C 7.84625 8.125 8.12563 7.84562 8.12563 7.5 V 6.79937 C 8.68563 6.67125 9.17875 6.37563 9.55625 5.9675 L 10.1669 6.31938 C 10.265 6.37625 10.3725 6.40312 10.4781 6.40312 C 10.6944 6.40312 10.905 6.29063 11.02 6.09 C 11.1925 5.79063 11.0894 5.40875 10.7906 5.23687 Z M 7.5 5 C 6.98313 5 6.5625 4.57937 6.5625 4.0625 C 6.5625 3.54562 6.98313 3.125 7.5 3.125 C 8.01688 3.125 8.4375 3.54562 8.4375 4.0625 C 8.4375 4.57937 8.01688 5 7.5 5 Z M 0 7.5 V 6.25 C 0 4.87125 1.12125 3.75 2.5 3.75 C 2.84562 3.75 3.125 4.02938 3.125 4.375 C 3.125 4.72062 2.84562 5 2.5 5 C 1.81062 5 1.25 5.56063 1.25 6.25 V 7.5 C 1.25 7.84562 0.970625 8.125 0.625 8.125 C 0.279375 8.125 0 7.84562 0 7.5 Z M 15 6.25 V 7.5 C 15 7.84562 14.7206 8.125 14.375 8.125 C 14.0294 8.125 13.75 7.84562 13.75 7.5 V 6.25 C 13.75 5.56063 13.1894 5 12.5 5 C 12.1544 5 11.875 4.72062 11.875 4.375 C 11.875 4.02938 12.1544 3.75 12.5 3.75 C 13.8787 3.75 15 4.87125 15 6.25 Z M 9.6875 14.375 C 9.6875 14.72 9.4075 15 9.0625 15 H 5.9375 C 5.5925 15 5.3125 14.72 5.3125 14.375 C 5.3125 13.4375 6.39813 12.5 7.5 12.5 C 8.60188 12.5 9.6875 13.4375 9.6875 14.375 Z M 4.0625 14.375 C 4.0625 14.72 3.7825 15 3.4375 15 H 0.625 C 0.28 15 0 14.72 0 14.375 C 0.041875 13.4619 0.989375 12.5 2.03125 12.5 C 3.07313 12.5 4.01312 13.4637 4.0625 14.375 Z M 3.58187 10.3125 C 3.58187 11.1756 2.8825 11.875 2.01937 11.875 C 1.15625 11.875 0.456875 11.1756 0.456875 10.3125 C 0.456875 9.44938 1.15625 8.75 2.01937 8.75 C 2.8825 8.75 3.58187 9.44938 3.58187 10.3125 Z M 5.9375 10.3125 C 5.9375 9.44938 6.63688 8.75 7.5 8.75 C 8.36312 8.75 9.0625 9.44938 9.0625 10.3125 C 9.0625 11.1756 8.36312 11.875 7.5 11.875 C 6.63688 11.875 5.9375 11.1756 5.9375 10.3125 Z M 11.4181 10.3125 C 11.4181 9.44938 12.1175 8.75 12.9806 8.75 C 13.8437 8.75 14.5431 9.44938 14.5431 10.3125 C 14.5431 11.1756 13.8437 11.875 12.9806 11.875 C 12.1175 11.875 11.4181 11.1756 11.4181 10.3125 Z M 15 14.375 C 15 14.72 14.72 15 14.375 15 H 11.5625 C 11.2175 15 10.9375 14.72 10.9375 14.375 C 10.9794 13.4619 11.9269 12.5 12.9688 12.5 C 14.0106 12.5 14.9506 13.4637 15 14.375 Z", "")}
          fill={iconFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1127_1575">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HubManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1580)">
      <path 
        d="M 15 6.277 V 15.0001 H 12.5 V 8.12512 C 12.5 7.62784 12.3025 7.15093 11.9508 6.79929 C 11.5992 6.44766 11.1223 6.25012 10.625 6.25012 H 4.37501 C 3.87773 6.25012 3.40081 6.44766 3.04918 6.79929 C 2.69755 7.15093 2.50001 7.62784 2.50001 8.12512 V 15.0001 H 0.00000646091 V 6.277 C -0.000742869 5.99225 0.0636972 5.71111 0.18839 5.45512 C 0.313082 5.19912 0.494718 4.97507 0.719382 4.80012 L 6.34438 0.398869 C 6.67386 0.139233 7.08114 -0.00195313 7.50063 -0.00195312 C 7.92012 -0.00195313 8.3274 0.139233 8.65688 0.398869 L 14.2819 4.80075 C 14.5064 4.97563 14.6878 5.19961 14.8123 5.45551 C 14.9368 5.71141 15.001 5.99243 15 6.277 Z M 11.25 8.12512 V 15.0001 H 3.75001 V 8.12512 C 3.75001 7.95936 3.81585 7.80039 3.93306 7.68318 C 4.05028 7.56597 4.20925 7.50012 4.37501 7.50012 H 10.625 C 10.7908 7.50012 10.9497 7.56597 11.0669 7.68318 C 11.1842 7.80039 11.25 7.95936 11.25 8.12512 Z M 8.75001 12.5001 H 6.25001 V 13.7501 H 8.75001 V 12.5001 Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1580">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const VehicleManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1585)">
      <path 
        d="M8.4375 2.8125H6.5625C4.75313 2.8125 3.28125 4.28438 3.28125 6.09375V11.7188C3.28125 12.4922 3.91406 13.125 4.6875 13.125H5.15625V12.1031C4.6125 11.9109 4.21875 11.3906 4.21875 10.7812V10.3125C4.21875 8.50313 5.69062 7.03125 7.5 7.03125C9.30937 7.03125 10.7812 8.50313 10.7812 10.3125V10.7812C10.7812 11.3906 10.3875 11.9109 9.84375 12.1031V13.125H10.3125C11.0859 13.125 11.7188 12.4922 11.7188 11.7188V6.09375C11.7188 4.28438 10.2469 2.8125 8.4375 2.8125ZM8.4375 5.27813L7.71094 6.36562C7.62188 6.50156 7.47187 6.57656 7.32188 6.57656C7.23281 6.57656 7.13906 6.54839 7.05938 6.49687C6.84375 6.35156 6.7875 6.06094 6.93281 5.84531L7.17183 5.48911H6.96089C6.78745 5.48911 6.62808 5.39067 6.5437 5.24067C6.46402 5.08598 6.47339 4.90317 6.56714 4.75786L7.2937 3.67036C7.43902 3.45473 7.72964 3.39848 7.94527 3.5438C8.16089 3.68442 8.21714 3.97505 8.07183 4.19067L7.83277 4.55161H8.0437C8.21714 4.55161 8.37652 4.64536 8.46089 4.80005C8.54058 4.95005 8.53125 5.1375 8.4375 5.27813Z"
        fill={iconFill}
      />
      <path 
        d="M5.15625 0.9375H4.21875C3.95987 0.9375 3.75 1.14737 3.75 1.40625V2.34375C3.75 2.60263 3.95987 2.8125 4.21875 2.8125H5.15625C5.41513 2.8125 5.625 2.60263 5.625 2.34375V1.40625C5.625 1.14737 5.41513 0.9375 5.15625 0.9375Z"
        fill={iconFill}
      />
      <path 
        d="M10.7812 0.9375H9.84375C9.58487 0.9375 9.375 1.14737 9.375 1.40625V2.34375C9.375 2.60263 9.58487 2.8125 9.84375 2.8125H10.7812C11.0401 2.8125 11.25 2.60263 11.25 2.34375V1.40625C11.25 1.14737 11.0401 0.9375 10.7812 0.9375Z"
        fill={iconFill}
      />
      <path 
        d="M8.90625 0H6.09375C5.3183 0 4.6875 0.540187 4.6875 1.20427V2.00714C4.6875 2.67122 5.3183 3.21141 6.09375 3.21141H8.90625C9.6817 3.21141 10.3125 2.67122 10.3125 2.00714V1.20427C10.3125 0.540187 9.6817 0 8.90625 0Z"
        fill={iconFill}
      />
      <path 
        d="M4.21875 2.34375H2.34375C2.08491 2.34375 1.875 2.13384 1.875 1.875C1.875 1.61616 2.08491 1.40625 2.34375 1.40625H4.21875C4.47759 1.40625 4.6875 1.61616 4.6875 1.875C4.6875 2.13384 4.47759 2.34375 4.21875 2.34375Z"
        fill={iconFill}
      />
      <path 
        d="M12.6563 2.34375H10.7813C10.5224 2.34375 10.3125 2.13384 10.3125 1.875C10.3125 1.61616 10.5224 1.40625 10.7813 1.40625H12.6563C12.9151 1.40625 13.125 1.61616 13.125 1.875C13.125 2.13384 12.9151 2.34375 12.6563 2.34375Z"
        fill={iconFill}
      />
      <path 
        d="M8.90625 10.7812V14.0625C8.90625 14.5781 8.48438 15 7.96875 15H7.03125C6.51563 15 6.09375 14.5781 6.09375 14.0625V10.7812H8.90625Z"
        fill={iconFill}
      />
      <path 
        d="M7.5 7.96875C6.20775 7.96875 5.15625 9.02025 5.15625 10.3125V10.7812C5.15625 11.0401 5.36616 11.25 5.625 11.25H9.375C9.63384 11.25 9.84375 11.0401 9.84375 10.7812V10.3125C9.84375 9.02025 8.79225 7.96875 7.5 7.96875Z"
        fill={iconFill}
      />
      <path d="M7.32103 7.51231C7.23178 7.51231 7.14136 7.48691 7.06149 7.43356C6.8461 7.29003 6.78797 6.99894 6.9315 6.78355L7.17024 6.42533H6.95897C6.78614 6.42533 6.62733 6.33013 6.54563 6.17769C6.46416 6.02525 6.47307 5.84033 6.56897 5.69656L7.29385 4.60939C7.43738 4.39377 7.72781 4.33541 7.94386 4.47941C8.15925 4.62294 8.21738 4.91403 8.07385 5.12942L7.83488 5.48783H8.04614C8.21897 5.48783 8.37778 5.58303 8.45949 5.73547C8.54096 5.88791 8.53205 6.07283 8.43614 6.21659L7.7115 7.30353C7.62108 7.43905 7.47253 7.51231 7.32103 7.51231Z" fill={iconFill}/>
    </g>
    <defs>
      <clipPath id="clip0_1127_1585">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const RentalManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1598)">
      <path 
        d={sidebarGlyph("M 10.3552 8.31885 C 10.553 8.37686 10.7332 8.49316 10.8685 8.6584 L 9.57124 9.36416 C 9.41508 9.1582 9.19741 8.99971 8.94165 8.91738 L 8.73657 8.85088 L 9.56127 8.40234 C 9.81381 8.26494 10.0995 8.24326 10.3552 8.31885 Z M 11.748 8.73428 L 9.78715 9.80156 C 9.8519 10.0356 9.8519 10.2899 9.77221 10.5381 C 9.55454 11.2125 8.8271 11.586 8.1521 11.3687 L 6.01606 10.6811 C 5.90473 10.6444 5.84262 10.5249 5.87807 10.4127 L 5.89712 10.3547 C 5.93286 10.2434 6.05327 10.1818 6.16547 10.2176 C 6.8771 10.4467 7.58901 10.6761 8.30151 10.9061 C 8.72075 11.0405 9.17426 10.8082 9.30874 10.3887 C 9.34624 10.2741 9.35532 10.1569 9.34126 10.0441 C 9.30317 9.74502 9.09721 9.47871 8.79223 9.38057 C 7.87378 9.08496 6.95532 8.78936 6.03686 8.49287 C 5.30122 8.25615 4.5811 8.32354 3.90258 8.69297 L 2.18081 9.62959 L 3.88003 12.5795 C 4.33442 12.3686 4.81254 12.341 5.30092 12.498 L 6.30756 12.8221 C 6.84077 12.994 7.36225 12.9451 7.85297 12.6776 L 12.5135 10.1414 C 12.9005 9.93135 13.045 9.44209 12.834 9.05508 C 12.6231 8.66777 12.1347 8.52334 11.748 8.73428 Z M 1.43022 9.30147 C 1.3728 9.20186 1.24419 9.16699 1.14458 9.22412 L 0.10483 9.82383 C 0.00522075 9.88125 -0.0296425 10.009 0.0274864 10.1086 L 2.36772 14.1712 C 2.42514 14.2708 2.55288 14.3057 2.65249 14.2477 L 3.69311 13.6488 C 3.79272 13.5914 3.82758 13.4628 3.77045 13.3632 L 1.43022 9.30147 Z M 4.34438 4.63008 L 4.7853 4.77363 C 4.84331 4.79268 4.88491 4.83662 4.90073 4.8958 C 4.96723 5.14834 5.06684 5.38652 5.19546 5.60654 C 5.22622 5.65957 5.22797 5.71963 5.20044 5.77441 L 4.9895 6.18809 C 4.95376 6.25693 4.96694 6.3375 5.02114 6.39141 L 5.44126 6.81152 C 5.49604 6.86631 5.57573 6.87891 5.64458 6.84404 L 6.05825 6.63311 C 6.11303 6.60498 6.1728 6.60645 6.22612 6.63809 C 6.44614 6.76611 6.68462 6.8666 6.93686 6.93193 C 6.99663 6.94775 7.03999 6.98936 7.05903 7.04736 L 7.20258 7.48916 C 7.22661 7.56211 7.29135 7.60957 7.3687 7.60957 H 7.96342 C 8.03989 7.60957 8.10551 7.56211 8.12954 7.48916 L 8.27309 7.04736 C 8.29214 6.98936 8.33549 6.94775 8.39526 6.93193 C 8.64692 6.86631 8.88598 6.76582 9.106 6.63809 C 9.15844 6.60645 9.21879 6.60498 9.27387 6.63311 L 9.68755 6.84404 C 9.75639 6.87891 9.83608 6.8666 9.89116 6.81152 L 10.3104 6.39141 C 10.3412 6.36152 10.3584 6.32344 10.362 6.2833 C 10.2632 6.29736 10.1627 6.3041 10.0614 6.3041 C 9.41684 6.3041 8.83881 6.01934 8.44682 5.56758 C 8.21508 5.69619 7.94936 5.77031 7.66606 5.77031 C 6.78071 5.77031 6.06323 5.05283 6.06323 4.1666 C 6.06323 3.28125 6.78071 2.56377 7.66606 2.56377 C 7.94936 2.56377 8.21508 2.6376 8.44682 2.7665 C 8.83881 2.31475 9.41684 2.0291 10.0614 2.0291 C 10.1627 2.0291 10.2632 2.03643 10.362 2.05078 C 10.3587 2.01094 10.3412 1.97285 10.3104 1.94268 L 9.89116 1.52256 C 9.83637 1.46777 9.75669 1.45518 9.68755 1.49004 L 9.27387 1.70098 C 9.21909 1.7291 9.15844 1.72676 9.106 1.696 C 8.88598 1.56797 8.64663 1.46777 8.39526 1.40127 C 8.33549 1.38633 8.29214 1.34473 8.27309 1.28672 L 8.12954 0.844922 C 8.10551 0.771973 8.03989 0.723633 7.96342 0.723633 H 7.3687 C 7.29135 0.723633 7.22661 0.77168 7.20258 0.844922 L 7.05903 1.28672 C 7.03999 1.34473 6.99663 1.38633 6.93686 1.40127 C 6.68432 1.46777 6.44614 1.56826 6.22612 1.696 C 6.17368 1.72676 6.11333 1.7291 6.05825 1.70098 L 5.64458 1.49004 C 5.57573 1.45518 5.49604 1.46748 5.44126 1.52256 L 5.02114 1.94268 C 4.96723 1.99658 4.95376 2.07715 4.9895 2.14541 L 5.20044 2.55996 C 5.22797 2.61475 5.22622 2.67451 5.19546 2.72783 C 5.06684 2.94785 4.96694 3.18633 4.90073 3.43857 C 4.88491 3.49746 4.84419 3.54141 4.7853 3.56074 L 4.34438 3.70371 C 4.27055 3.72773 4.22309 3.79336 4.22309 3.8707 V 4.46455 C 4.22309 4.54131 4.27026 4.60693 4.34438 4.63008 Z M 14.9999 4.1666 C 14.9999 4.21318 14.9818 4.25303 14.946 4.28291 L 14.4187 4.72881 C 14.3906 4.75283 14.3581 4.76455 14.3208 4.76455 H 14.1125 L 13.884 4.47568 C 13.8442 4.425 13.7917 4.425 13.751 4.47568 L 13.5228 4.76455 H 13.1733 L 12.9442 4.47568 C 12.9043 4.425 12.8519 4.425 12.8121 4.47568 L 12.583 4.76455 H 11.6012 C 11.3613 5.38066 10.7624 5.81836 10.0617 5.81836 C 9.14995 5.81836 8.41079 5.07832 8.41079 4.1666 C 8.41079 3.25488 9.14995 2.51572 10.0617 2.51572 C 10.7624 2.51572 11.3613 2.95254 11.6012 3.56865 H 14.3208 C 14.3583 3.56865 14.3906 3.58125 14.4187 3.60527 L 14.946 4.05117 C 14.9818 4.08105 14.9999 4.1209 14.9999 4.1666 Z M 9.82876 4.1666 C 9.82876 3.96299 9.66352 3.79717 9.45932 3.79717 C 9.25512 3.79717 9.08989 3.96328 9.08989 4.1666 C 9.08989 4.3708 9.25512 4.53604 9.45932 4.53604 C 9.66352 4.53604 9.82876 4.37109 9.82876 4.1666 Z", "")}
          fill={iconFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1127_1598">
          <rect width="15" height="15" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export const PaymentManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1603)">
      <path 
        d="M 13.1251 5 H 3.12514 C 2.58826 5 2.08014 4.76687 1.72826 4.375 C 1.77701 4.32 1.82951 4.26813 1.88514 4.21875 C 2.14389 3.99 2.16889 3.595 1.94014 3.33625 C 1.71139 3.07687 1.31639 3.0525 1.05764 3.28125 C 0.792012 3.51562 0.571387 3.78937 0.401387 4.0925 C 0.140762 4.55562 -0.000488281 5.0825 -0.000488281 5.625 V 11.875 C -0.000488281 13.5981 1.40139 15 3.12451 15 H 13.1245 C 14.1583 15 14.9995 14.1587 14.9995 13.125 V 6.875 C 14.9995 5.84125 14.1589 5 13.1251 5 Z M 11.5626 10.9375 C 11.0451 10.9375 10.6251 10.5175 10.6251 10 C 10.6251 9.4825 11.0451 9.0625 11.5626 9.0625 C 12.0801 9.0625 12.5001 9.4825 12.5001 10 C 12.5001 10.5175 12.0801 10.9375 11.5626 10.9375 Z M 9.37514 1.875 C 10.4108 1.875 11.2501 2.71438 11.2501 3.75 H 13.1251 C 13.8189 3.75187 14.4695 3.98813 15.0001 4.39563 V 1.875 C 15.0001 0.839375 14.1608 0 13.1251 0 H 5.62514 C 4.58951 0 3.75014 0.839375 3.75014 1.875 V 3.75 H 7.50014 C 7.50014 2.71438 8.33951 1.875 9.37514 1.875 Z M 13.1251 0.9375 C 13.6426 0.9375 14.0626 1.3575 14.0626 1.875 C 14.0626 2.3925 13.6426 2.8125 13.1251 2.8125 C 12.6076 2.8125 12.1876 2.3925 12.1876 1.875 C 12.1876 1.3575 12.6076 0.9375 13.1251 0.9375 Z M 5.62514 2.8125 C 5.10764 2.8125 4.68764 2.3925 4.68764 1.875 C 4.68764 1.3575 5.10764 0.9375 5.62514 0.9375 C 6.14264 0.9375 6.56264 1.3575 6.56264 1.875 C 6.56264 2.3925 6.14264 2.8125 5.62514 2.8125 Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1603">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const BookingManagementIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1608)">
      <path 
        d="M14.0625 4.6875V3.28125C14.0625 2.90829 13.9143 2.5506 13.6506 2.28688C13.3869 2.02316 13.0292 1.875 12.6562 1.875H10.7812V1.40625C10.7812 1.28193 10.7319 1.1627 10.644 1.07479C10.556 0.986886 10.4368 0.9375 10.3125 0.9375C10.1882 0.9375 10.069 0.986886 9.98104 1.07479C9.89314 1.1627 9.84375 1.28193 9.84375 1.40625V1.875H5.15625V1.40625C5.15625 1.28193 5.10686 1.1627 5.01896 1.07479C4.93105 0.986886 4.81182 0.9375 4.6875 0.9375C4.56318 0.9375 4.44395 0.986886 4.35604 1.07479C4.26814 1.1627 4.21875 1.28193 4.21875 1.40625V1.875H2.34375C1.97079 1.875 1.6131 2.02316 1.34938 2.28688C1.08566 2.5506 0.9375 2.90829 0.9375 3.28125V4.6875H14.0625Z"
        fill={iconFill}
      />
      <path 
        d="M0.9375 5.625V12.6562C0.9375 13.0292 1.08566 13.3869 1.34938 13.6506C1.6131 13.9143 1.97079 14.0625 2.34375 14.0625H12.6562C13.0292 14.0625 13.3869 13.9143 13.6506 13.6506C13.9143 13.3869 14.0625 13.0292 14.0625 12.6562V5.625H0.9375ZM10.1484 8.32453L6.86719 11.137C6.7775 11.2137 6.66219 11.2537 6.54428 11.2491C6.42636 11.2445 6.31453 11.1956 6.23109 11.1122L4.82484 9.70594C4.73946 9.61753 4.69221 9.49912 4.69328 9.37622C4.69435 9.25331 4.74364 9.13575 4.83055 9.04884C4.91746 8.96193 5.03503 8.91263 5.15794 8.91156C5.28084 8.91049 5.39925 8.95774 5.48766 9.04312L6.58734 10.1428L9.54047 7.61156C9.58695 7.56967 9.64134 7.53751 9.70044 7.51697C9.75955 7.49643 9.82216 7.48794 9.8846 7.49198C9.94704 7.49602 10.008 7.51253 10.064 7.54052C10.12 7.56851 10.1698 7.60742 10.2104 7.65496C10.2511 7.7025 10.2819 7.7577 10.3009 7.81731C10.3199 7.87693 10.3268 7.93974 10.3211 8.00205C10.3155 8.06437 10.2974 8.12492 10.268 8.18015C10.2386 8.23537 10.1984 8.28414 10.1498 8.32359L10.1484 8.32453Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1608">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const SupportSystemIcon: React.FC<IconProps> = ({ 
  width = 15, 
  height = 15, 
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;
  
  return (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1127_1615)">
      <path 
        d="M 13.125 13.4374 V 14.9999 H 1.87504 V 13.4374 C 1.87504 11.8868 3.13691 10.6249 4.68754 10.6249 H 10.3125 C 11.8632 10.6249 13.125 11.8868 13.125 13.4374 Z M 4.29504 2.51682 C 5.25066 1.62119 6.50191 1.17869 7.81379 1.25994 C 10.2663 1.41869 12.1882 3.55307 12.1882 6.11869 C 12.1882 7.22494 11.2888 8.12432 10.1825 8.12432 H 8.67879 C 8.52629 7.60619 8.05254 7.22494 7.48504 7.22494 C 6.79441 7.22494 6.23504 7.78432 6.23504 8.47494 C 6.23504 9.16557 6.79441 9.72494 7.48504 9.72494 C 7.82129 9.72494 8.12566 9.59057 8.35004 9.37432 H 10.1825 C 11.9775 9.37432 13.4382 7.91369 13.4382 6.11869 C 13.4375 2.89619 11.0025 0.213694 7.89379 0.0130686 C 6.22879 -0.0950564 4.64941 0.470569 3.44004 1.60557 C 2.32316 2.65244 1.65191 4.10307 1.57129 5.62557 H 2.82316 C 2.90004 4.43619 3.41566 3.34119 4.29504 2.51682 Z M 9.43754 6.87494 H 10.2925 C 10.6057 6.87494 10.8794 6.64494 10.9157 6.33369 C 10.9582 5.96682 10.9425 5.58244 10.8588 5.18932 C 10.5813 3.88994 9.52691 2.84182 8.22566 2.57432 C 6.01504 2.11994 4.06379 3.80557 4.06379 5.93744 C 4.06379 6.85557 4.42566 7.69057 5.01379 8.30744 C 5.08254 6.98807 6.16441 5.93682 7.50066 5.93682 C 8.28691 5.93682 8.97941 6.30682 9.43754 6.87432 V 6.87494 Z"
        fill={iconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1127_1615">
        <rect width="15" height="15" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const RideManagementIcon: React.FC<IconProps> = ({
  width = 15,
  height = 15,
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false,
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(0, -2)">
        <>
            <path
              d="M12.3009 9.55895H11.1402C10.5196 9.55895 10.0147 9.00396 10.0147 8.32178V8.30245C10.0147 7.62026 10.5196 7.06528 11.1402 7.06528H11.7365C11.6123 6.90218 11.4794 6.6994 11.3569 6.48535H11.1402C10.2287 6.48535 9.48709 7.30049 9.48709 8.30245V8.32178C9.48709 9.32373 10.2287 10.1389 11.1402 10.1389H12.3009C12.9215 10.1389 13.4264 10.6939 13.4264 11.376V11.3954C13.4264 12.0776 12.9215 12.6326 12.3009 12.6326H9.73304C9.58735 12.6326 9.46924 12.7624 9.46924 12.9226C9.46924 13.0827 9.58735 13.2125 9.73304 13.2125H12.3009C13.2124 13.2125 13.954 12.3974 13.954 11.3954V11.376C13.9541 10.3741 13.2124 9.55895 12.3009 9.55895Z"
              fill={iconFill}
            />
            <path
              d="M11.317 5.57292C11.5911 5.87629 11.789 6 12 6C12.211 6 12.4089 5.87627 12.683 5.57292C12.8647 5.37174 13.0686 5.10015 13.257 4.80812C13.4804 4.46199 14 3.58765 14 2.94584C14 1.87289 13.1028 1 12 1C10.8972 1 10 1.87289 10 2.94584C10 3.58763 10.5196 4.46199 10.7429 4.80812C10.9314 5.10015 11.1353 5.37174 11.317 5.57292ZM12 2.55925C12.2189 2.55925 12.3974 2.7329 12.3974 2.94584C12.3974 3.15877 12.2189 3.33243 12 3.33243C11.7811 3.33243 11.6026 3.15877 11.6026 2.94584C11.6026 2.7329 11.7812 2.55925 12 2.55925Z"
              fill={iconFill}
            />
            <g clipPath="url(#clip0_2391_1258)">
              <path
                d="M2.2477 13.5243C2.96353 13.5155 3.53673 12.9282 3.52798 12.2125C3.51924 11.4968 2.93186 10.9237 2.21604 10.9324C1.50021 10.9412 0.927011 11.5285 0.935756 12.2442C0.9445 12.9599 1.53188 13.533 2.2477 13.5243Z"
                fill={iconFill}
              />
              <path
                d="M8.16274 13.5253C8.87857 13.5165 9.45177 12.9292 9.44302 12.2135C9.43428 11.4978 8.8469 10.9246 8.13108 10.9334C7.41525 10.9421 6.84205 11.5294 6.85079 12.2452C6.85954 12.9609 7.44692 13.534 8.16274 13.5253Z"
                fill={iconFill}
              />
              <path
                d="M5.53237 7.21556C5.60916 7.29177 5.71273 7.33491 5.82091 7.33574L6.52394 9.86702C6.65077 10.3234 6.53725 10.8172 6.21158 11.1613C6.21158 11.1613 5.79323 11.6121 5.16693 11.6128C4.96934 11.6114 4.78032 11.5319 4.64113 11.3916C4.50194 11.2514 4.42387 11.0618 4.42397 10.8642C4.42393 10.5907 4.45448 10.318 4.51506 10.0513C4.5932 9.74527 4.64418 9.64541 4.7379 9.45341C5.04378 9.41154 5.16185 8.96148 4.93569 8.59499C4.69848 8.20958 4.17853 8.16543 3.55171 8.38476C2.92489 8.6041 2.33924 8.48585 1.52987 8.34745C0.716127 8.20835 0.588766 9.45691 1.17652 9.45691H1.5318C1.11175 9.70702 0.770513 10.0702 0.547071 10.5051C0.521486 10.5543 0.505858 10.6081 0.50108 10.6634C0.496302 10.7187 0.502468 10.7744 0.519226 10.8273C0.535984 10.8802 0.563005 10.9293 0.598744 10.9718C0.634483 11.0142 0.67824 11.0492 0.727514 11.0748C0.774544 11.0984 0.827769 11.1068 0.879791 11.0988C0.931814 11.0908 0.980051 11.0668 1.0178 11.0301C1.21328 10.8313 1.45484 10.684 1.721 10.6011C1.88689 10.5514 2.05888 10.5251 2.23202 10.5229C2.68435 10.5234 3.118 10.7034 3.43783 11.0232C3.75765 11.3431 3.93753 11.7767 3.938 12.2291C3.938 12.2641 3.93694 12.2994 3.93484 12.3351C3.93408 12.347 3.93577 12.359 3.93983 12.3703C3.94389 12.3816 3.95022 12.3919 3.95843 12.4007C3.96664 12.4094 3.97656 12.4164 3.98757 12.4211C3.99858 12.4258 4.01045 12.4283 4.02244 12.4283H6.00205C6.11452 12.4251 6.22209 12.3815 6.30511 12.3056C6.38812 12.2297 6.44105 12.1264 6.45421 12.0146C6.49533 11.6907 6.62853 11.3853 6.83801 11.1348C7.04749 10.8842 7.32445 10.6991 7.63602 10.6012C7.80191 10.5516 7.9739 10.5253 8.14705 10.5231C8.54107 10.5228 8.92294 10.6594 9.22725 10.9097C9.35128 11.0115 9.52735 10.8684 9.45114 10.7272L9.44904 10.7235C9.19594 10.2746 8.81153 9.91394 8.34746 9.68991C8.28106 9.65768 8.21379 9.62877 8.14617 9.60232C8.12339 8.43066 6.76342 7.33627 6.76342 7.33627C7.12868 7.35764 7.14147 6.99395 7.14147 6.99395C7.16389 6.55301 6.86538 6.19965 6.45351 6.17548C6.34977 6.1701 6.24692 6.19709 6.15919 6.25274L5.92094 6.40235C5.84118 6.45372 5.75699 6.49787 5.66937 6.53426C5.60907 6.55865 5.55533 6.59684 5.51246 6.64577C5.46959 6.69469 5.43879 6.75298 5.42253 6.81596C5.42253 6.81596 5.31269 6.84855 5.2724 6.88604C5.2439 6.91039 5.22305 6.94246 5.21238 6.9784C5.2017 7.01433 5.20164 7.05258 5.21222 7.08854C5.22279 7.12451 5.24354 7.15664 5.27197 7.18108C5.3004 7.20551 5.33529 7.2212 5.37243 7.22625C5.37243 7.22625 5.42849 7.23571 5.53237 7.21556Z"
                fill={iconFill}
              />
            </g>
            <defs>
              <clipPath id="clip0_2391_1258">
                <rect
                  width="8.96959"
                  height="8.96959"
                  fill="white"
                  transform="translate(0.5 5.36426)"
                />
              </clipPath>
            </defs>
          </>
      </g>
    </svg>
  );
};

export const SettingsIcon: React.FC<IconProps> = ({
  width = 15,
  height = 15,
  fill = SIDEBAR_ICON_INACTIVE,
  className,
  isActive = false,
}) => {
  const iconFill = isActive ? SIDEBAR_ICON_ACTIVE : fill;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2762_4025)">
        <path
          d="M1.00457 11.25C1.52154 12.1472 2.66802 12.4555 3.56526 11.9385C3.56588 11.9382 3.56646 11.9378 3.56708 11.9375L3.84519 11.7768C4.37019 12.226 4.97365 12.5744 5.62518 12.8043V13.125C5.62518 14.1605 6.46466 15 7.50018 15C8.53571 15 9.37518 14.1605 9.37518 13.125V12.8044C10.0268 12.574 10.6303 12.2253 11.1552 11.7756L11.4345 11.9369C12.332 12.4546 13.4793 12.1468 13.9971 11.2494C14.5148 10.3519 14.207 9.20461 13.3095 8.68685L13.032 8.52686C13.157 7.84714 13.157 7.15034 13.032 6.4706L13.3095 6.31061C14.207 5.79284 14.5148 4.64558 13.9971 3.7481C13.4793 2.85064 12.332 2.54282 11.4345 3.06059L11.1564 3.22122C10.6309 2.7726 10.027 2.4249 9.37518 2.19563V1.875C9.37518 0.839473 8.53571 0 7.50018 0C6.46466 0 5.62518 0.839473 5.62518 1.875V2.19563C4.97356 2.42599 4.37008 2.77474 3.84519 3.22438L3.56582 3.06252C2.66834 2.54473 1.52107 2.85255 1.00331 3.75C0.485545 4.64745 0.793338 5.79475 1.69082 6.31251L1.96832 6.4725C1.8434 7.15222 1.8434 7.84901 1.96832 8.52876L1.69082 8.68875C0.795828 9.20789 0.489031 10.3529 1.00457 11.25ZM7.50018 5.00001C8.88089 5.00001 10.0002 6.1193 10.0002 7.5C10.0002 8.8807 8.88089 9.99999 7.50018 9.99999C6.11948 9.99999 5.00019 8.8807 5.00019 7.5C5.00019 6.1193 6.11948 5.00001 7.50018 5.00001Z"
          fill={iconFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2762_4025">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};